namespace SorAraBul.Administration {
    export interface CompaniesRow {
        CompanyId?: number;
        Name?: string;
        TaxOffice?: string;
        TaxNumber?: string;
        AddressDetail?: string;
        ContactNumber?: string;
        PostalCode?: string;
        Created?: string;
        CreatedBy?: string;
        LastModified?: string;
        LastModifiedBy?: string;
        IsActive?: number;
        Credit?: number;
        CityId?: number;
        CityName?: string;
        IlceId?: number;
        TownName?: string;
    }

    export namespace CompaniesRow {
        export const idProperty = 'CompanyId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Administration.Companies';
        export const lookupKey = 'Administration.Companies';

        export function getLookup(): Q.Lookup<CompaniesRow> {
            return Q.getLookup<CompaniesRow>('Administration.Companies');
        }
        export const deletePermission = 'Administration:CompanyAdmin';
        export const insertPermission = 'Administration:CompanyAdmin';
        export const readPermission = 'Administration:CompanyAdmin';
        export const updatePermission = 'Administration:CompanyAdmin';

        export declare const enum Fields {
            CompanyId = "CompanyId",
            Name = "Name",
            TaxOffice = "TaxOffice",
            TaxNumber = "TaxNumber",
            AddressDetail = "AddressDetail",
            ContactNumber = "ContactNumber",
            PostalCode = "PostalCode",
            Created = "Created",
            CreatedBy = "CreatedBy",
            LastModified = "LastModified",
            LastModifiedBy = "LastModifiedBy",
            IsActive = "IsActive",
            Credit = "Credit",
            CityId = "CityId",
            CityName = "CityName",
            IlceId = "IlceId",
            TownName = "TownName"
        }
    }
}
